@if (isLoading) {
<div class="flex items-center justify-center h-screen">
  <div class="text-center">
    <img
      class="w-72 h-auto mx-auto mb-6"
      [ngSrc]="
        isLightMode()
          ? '../../../assets/icons/logo-j-connected_blue_2.png'
          : '../../../assets/icons/logo-j-connected_white.png'
      "
      height="79"
      width="190"
      alt="Johnston's Connected"
      priority
    />
    <p class="text-gray-400 text-xl">Trading Platform</p>
  </div>
</div>
} @if (!isLoading) {
<div
  class="flex items-center flex-col justify-center ztablet-min:bg-gray-100 h-screen"
>
  <div
    class="flex flex-col items-center justify-center max-w-md w-full rounded-xl p-4"
  >
    <img
      class="w-48 h-auto mx-auto mb-6"
      [ngSrc]="
        isLightMode()
          ? '../../../assets/icons/logo-j-connected_blue_2.png'
          : '../../../assets/icons/logo-j-connected_white.png'
      "
      height="79"
      width="190"
      alt="Johnston's Connected"
      priority
    />
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <mat-form-field class="w-full">
        <mat-label>Email</mat-label>
        <input
          type="email"
          matInput
          formControlName="email"
          placeholder="your@email.com"
        />
        @if (loginForm.get('email')?.hasError('required')) {
        <mat-error> Email is required. </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Password</mat-label>
        <input
          #passwordInput
          [type]="hidePassword ? 'password' : 'text'"
          matInput
          formControlName="password"
          placeholder="Your password"
        />
        <button
          matSuffix
          mat-icon-button
          type="button"
          (click)="togglePasswordVisibility()"
          [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
          class="password-toggle-btn"
        >
          <mat-icon>{{
            hidePassword ? "visibility" : "visibility_off"
          }}</mat-icon>
        </button>
        @if (loginForm.get('password')?.hasError('required')) {
        <mat-error> Password is required. </mat-error>
        }
      </mat-form-field>
      <button
        type="submit"
        class="bg-custom-orange text-white text-md p-3 rounded-xl mt-4 w-full"
      >
        Log in
      </button>
    </form>
    <button
      routerLink="/register"
      class="hover:bg-custom-orange hover:outline-none outline-slate-400 outline outline-1 hover:text-white text-slate-400 text-md p-3 rounded-xl mt-4 w-full"
    >
      Create Account
    </button>
    <button class="text-gray-400 text-md mt-4" routerLink="/forgot-password">
      Forgot password?
    </button>
  </div>
  <div
    class="w-1/5 desktop-max:w-full px-3 mx-auto text-center text-xs tablet-max:text-sm"
  >
    <p class="text-gray-300 mx-auto">
      By utilizing this application, you consent to adhere to our
      <a [href]="links.termsOfService" target="_blank" class="text-orange-300"
        >terms of use</a
      >
      and
      <a
        [href]="links.privacyPolicy"
        class="text-orange-300"
        target="_blank"
        text-orange-300
        >privacy policy</a
      >
    </p>
  </div>
</div>
}
